import { Card, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import PageTitle from '../../common/PageTitle';
import { useTranslation } from 'react-i18next';
import { useGetCourseDraftDetailsQuery } from '../../../features/courses/coursesApi';
import { useNavigate, useParams } from 'react-router';
import CourseDescription from '../components/courseDescription';
import getActions, { AddComponentButton } from '../actions/courseEditActions';
import CourseEditableSteps from '../components/courseEditableSteps';

const CourseDraftDetail = () => {
    const { t } = useTranslation();
    const { courseDraftId } = useParams();
    const { data: course } = useGetCourseDraftDetailsQuery(courseDraftId);
    const [courseDescription, setCourseDescription] = useState('');
    const [courseSteps, setCourseSteps] = useState([]);
    const [editable, setEditable] = useState(true);

    useEffect(() => {
        if (course) {
            setCourseDescription(course.description);
            setCourseSteps(course.steps);
            setEditable(!course.is_published);
        }
    }, [course]);

    const courseTitle = (course) => {
        if (course) {
            if (course.is_published) {
                return `${course.title} (${t('published')})`;
            } else {
                return `${course.title} (${t('draft')})`;
            }
        } else {
            return '';
        }
    };

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <PageTitle
                title={courseTitle(course) as string}
                actions={getActions({
                    id: courseDraftId as string,
                    steps: courseSteps,
                    description: courseDescription,
                    editable: editable,
                })}
                subtitle={t('draft') as string}
            />
            <CourseDescription
                description={courseDescription}
                editable={editable ? { onChange: setCourseDescription } : false}
            />
            <Card>
                <CourseEditableSteps
                    onStepsUpdate={setCourseSteps}
                    steps={courseSteps}
                    editable={editable}
                />
                {editable && (
                    <AddComponentButton
                        steps={courseSteps}
                        onStepsUpdate={setCourseSteps}
                    />
                )}
            </Card>
        </Space>
    );
};

export default CourseDraftDetail;
